export const APP_FILE_IMPORTS_ROUTE = "/imports";
export const APP_FILE_AGENCY_BILL_ROUTE = "/manual-reconciliation";
export const APP_FILE_MANUAL_BANK_RECONCILIATION_ROUTE = "/manual-bank-reconciliation";
export const APP_EXCEL_FILE_IMPORTS_ROUTE = APP_FILE_IMPORTS_ROUTE + "/excel";
export const APP_PDF_FILE_IMPORTS_ROUTE = APP_FILE_IMPORTS_ROUTE + "/pdf";
export const APP_EXTRACT_PRODUCST_WITH_API=APP_FILE_IMPORTS_ROUTE+"/pdf/extract-and-validate";
